import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import {
    IRequestData,
    IHorizon,
    IFilterHorizons,
} from '../../../types';
import { AuthContext } from '../../../contexts/Auth/AuthContext';
import apiService from '../../../services/apiService';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';

interface IHorizonProps {
    examId: string | undefined
    horizon: IHorizon
    horizonFilters: IFilterHorizons
    renewHorizon: (data: Array<IHorizon> | undefined) => void
}

export default function HorizonConsistencyItem(props: IHorizonProps) {
    const styles = useStyles();
    const auth = React.useContext(AuthContext);
    const [consistencyDrought, setConsistencyDrought] = useState<string>('0');
    const [consistencyWet, setConsistencyWet] = useState<string>('0');
    const [consistencyUpdate, setConsistencyUpdate] = useState<boolean>(false);

    async function updateHorizon() {
        if (auth !== undefined && props.examId !== undefined && props.horizon !== undefined) {
            let request_data: IRequestData = {
                horizon_id: props.horizon.id,
                exam_id: parseInt(props.examId),
            };

            if (
                consistencyDrought !== null &&
                consistencyDrought !== '0' &&
                props.horizon.consistency_drought !== `${consistencyDrought}`
            ) {
                request_data['consistency_drought'] = `${consistencyDrought}`;
            }
            if (
                consistencyWet !== null &&
                consistencyWet !== '0' &&
                props.horizon.consistency_wet !== `${consistencyWet}`
            ) {
                request_data['consistency_wet'] = `${consistencyWet}`;
            }

            try {
                await apiService.put(
                    'exams/horizon',
                    request_data
                ).then((response) => {
                    if (response !== undefined && response.status === 200) {
                        props.renewHorizon(response.data.data as Array<IHorizon>);
                    }
                }).catch(() => {
                });
            } catch (e) {
            }
        }
    }

    useEffect(() => {
        if (consistencyUpdate === true) {
            updateHorizon();
            setConsistencyUpdate(false);
        }
        return () => setConsistencyUpdate(false);
        // eslint-disable-next-line
    },[consistencyUpdate]);

    useEffect(() => {
        if (props.horizon !== undefined) {
            setConsistencyDrought((props.horizon.consistency_drought === null ? '0' : props.horizon.consistency_drought));
            setConsistencyWet((props.horizon.consistency_wet === null ? '0' : props.horizon.consistency_wet));
        }
        // eslint-disable-next-line
    }, [props]);

    return (
        <Grid container key={`${props.horizon.id}${props.horizon.name}consistency_drought`} className={styles.view_horizon_consistency}>
            <Grid item xs={12} className={styles.view_horizon_consistency_title}>
                <Typography className={styles.text_horizon_consistency}>
                    <strong>{props.horizon.name}</strong>
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_consistency_subtitle}>
                <Typography className={styles.text_horizon_consistency_subtitle}>
                    Seca
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_consistency_subtitle}>
                <TextField
                    className={styles.picker_select_type}
                    select
                    value={consistencyDrought ? consistencyDrought : "0"}
                    defaultValue={'0'}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setConsistencyDrought(`${event.target.value}`);
                        setConsistencyUpdate(true);
                    }}
                >
                    <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                    {props.horizonFilters.consistency_drought.map((element, key) => (
                        <MenuItem className={styles.picker_select_item} key={key} value={`${key+1}`}>{`${element}`}</MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_consistency_subtitle}>
                <Typography className={styles.text_horizon_consistency_subtitle}>
                    Úmida
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_consistency_subtitle}>
                <TextField
                    className={styles.picker_select_type}
                    select
                    value={consistencyWet ? consistencyWet : "0"}
                    defaultValue={'0'}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setConsistencyWet(`${event.target.value}`);
                        setConsistencyUpdate(true);
                    }}
                >
                    <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                    {props.horizonFilters.consistency_wet.map((element, key) => (
                        <MenuItem className={styles.picker_select_item} key={key} value={`${key+1}`}>{`${element}`}</MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );
}